import { createFileRoute } from "@tanstack/react-router";
import { SwapPage } from "../../features/swap/pages/swap-page";
import { prefetchSdkSwapMetadata } from "../../shared/utils/metadata-data";
import { prefetchSdkTokens } from "../../shared/utils/tokens-data";

export const Route = createFileRoute("/_layout/swap")({
  validateSearch: (search: Record<string, unknown>) => {
    // Preserve values to prevent TanStack Router from removing them
    const result: {
      fromChainId?: string;
      fromTokenAddress?: string;
      toChainId?: string;
      toTokenAddress?: string;
    } = {};

    if (search.fromChainId !== undefined) {
      result.fromChainId = String(search.fromChainId);
    }

    if (search.fromTokenAddress !== undefined) {
      result.fromTokenAddress = String(search.fromTokenAddress).toLowerCase();
    }

    if (search.toChainId !== undefined) {
      result.toChainId = String(search.toChainId);
    }

    if (search.toTokenAddress !== undefined) {
      result.toTokenAddress = String(search.toTokenAddress).toLowerCase();
    }

    return result;
  },
  loader: () => {
    // Fire and forget with error handling
    prefetchSdkSwapMetadata().catch(console.warn);
    prefetchSdkTokens().catch(console.warn);
    return null; // resolves immediately; route can render
  },
  component: SwapPage,
});
